import useReactHookForm from "hooks/useReactHookForm";
import { useAppDispatch } from "hooks/redux";
import { Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation, useLazyQuery } from "@apollo/client";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  hasAtLeastOneValue,
  VenProUsersInitialValues,
  VenProUsersMandatoryFields,
  VenProUsersProperties,
  VenProUsersValidationSchema,
} from "./helper";
import liveClassClientService from "utils/graphql/liveclassClient";
import {
  CREATE_VENDOR_PROJECT_USER,
} from "utils/graphql/services/live-classes/mutations";
import {
  GET_VENDOR_USERS,
} from "utils/graphql/services/live-classes/queries";
import { useEffect } from "react";
import { metadataUpdate } from "app-component/slices/metadata-slice";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";

export const CreateVendorProjectUsers = () => {

  const dispatch = useAppDispatch();
  const history = useHistory();

  const { control, errors, getValues, watch, setValue } =
    useReactHookForm(
      VenProUsersInitialValues,
      VenProUsersValidationSchema,
      VenProUsersMandatoryFields
    );

  const selectedUserType = watch("userType");
  const [getVendorUsers] = useLazyQuery(GET_VENDOR_USERS, {
    client: liveClassClientService,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    return () => {
      dispatch(
        metadataUpdate({
          key: "vendor_user_by_type_gq",
          value: [],
        })
      );
    };
  }, []);

  useEffect(() => {
    if (!selectedUserType || selectedUserType === "") {
      dispatch(
        metadataUpdate({
          key: "vendor_user_by_type_gq",
          value: [],
        })
      );

      setValue("vendorUserId", []);
      return;
    }

    (async () => {
      try {
        const { data } = await getVendorUsers({
          variables: {
            input: {
              userType: selectedUserType,
              isUsed: false,
              limit: 50,
              offset: 0,
            },
          },
        });
        const vendorUsers =
          data?.getVendorUsers?.vendorUsers || [];

        dispatch(metadataUpdate({ key: "vendor_user_by_type_gq", value: vendorUsers }));

        setValue("vendorUserId", []);
      } catch (error) {
        console.error("Error fetching vendor users:", error);
      }
    })();
  }, [selectedUserType]);

  const [createVendorProjectUsers, { loading }] =
    useMutation(CREATE_VENDOR_PROJECT_USER, {
      client: liveClassClientService,
    });

  const handleCreateVendorProjectUsers = async () => {
    try {
      const response: any =
        await createVendorProjectUsers({
          variables: {
            input: {
              vendorId: Number(watch()?.vendorId),
              vendorAccountId: Number(watch()?.vendorAccountId),
              projectId: Number(watch()?.projectId),
              // userType: watch()?.userType,
              vendorUserIds:
                watch()?.vendorUserId?.map((id: string) =>
                  Number(id)
                ) || [],
            },
          },
        });

      if (response?.data?.createVendorProjectUser?.message) {
        dispatch(
          snackbarRequest({
            message:
              response?.data?.createVendorProjectUser
                ?.message ||
              "Created Vendor Project Users successfully",
          })
        );
        history.replace(
          `/live-classes/vendor-project-users`
        );
      } else {
        dispatch(
          snackbarRequest({
            message: "Failed to create Vendor Project Users",
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message:
            `${err?.message}` ||
            "Failed to create Vendor Project Users",
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>
        Create Vendor Project Users
      </TypographyHeading>

      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={VenProUsersProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />

          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateVendorProjectUsers}
              loading={loading}
              disabled={!isFieldsValidate(errors, VenProUsersMandatoryFields, getValues)}
            >
              Create
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};